export const state = {
    authentication: {
        isAuthenticated: false,
        openId: '',
        accessToken: '',
        refreshToken: '',
        secretKey: '',
    },
    query: {
        client_id: '',
        redirect_uri: '',
        queryScopes: '',
        scopes: [],
        secret_key: '',
        input_email: '',
        input_phone: '',
    },
    client: {
        name: '',
        photo: '',
        company_info: { name: '' },
        domain: '',
        id: '',
        client_id: '',
        channel_allows: []
    }
};

export const mutations = {
    SET_IS_AUTHENTICATED (state, newValue) {
        state.authentication.isAuthenticated = newValue
    },
    SET_ACCESS_TOKEN (state, newValue) {
        state.authentication.accessToken = newValue
    },
    SET_REFRESH_TOKEN (state, newValue) {
        state.authentication.refreshToken = newValue
    },
    SET_SECRET_KEY (state, newValue) {
        state.authentication.secretKey = newValue
    },
    SET_AUTHENTICATED_ALL (state, newValue) {
        console.log('SET_AUTHENTICATED_ALL', newValue)
        state.authentication.isAuthenticated = newValue.isAuthenticated
        state.authentication.accessToken = newValue.accessToken
        state.authentication.refreshToken = newValue.refreshToken
        state.authentication.secretKey = newValue.secretKey
        state.authentication.openId = newValue.openId
    },
    SET_REMOVE_ALL (state) {
        state.authentication.isAuthenticated = false
        state.authentication.accessToken = ''
        state.authentication.refreshToken = ''
        state.authentication.secretKey = ''
        state.authentication.openId = ''
    },
    REMOVE_EXPIRE_TOKEN (state) {
        state.authentication.isAuthenticated = false,
        state.authentication.accessToken = ''
        state.authentication.refreshToken = ''
        state.authentication.secretKey = ''
        state.authentication.openId = ''
    },
    ADD_QUERY: (state, data) => {
        state.query = data;
    },
    SET_QUERY_CLIENT_ID (state, newValue) {
        state.query.client_id = newValue
    },
    SET_QUERY_REDIRECT_URI (state, newValue) {
        state.query.redirect_uri = newValue
    },
    SET_QUERY_SCOPES (state, newValue) {
        state.query.queryScopes = newValue
    },
    SET_QUERY_OBJ_SCOPES (state, newValue) {
        state.query.scopes = newValue
    },
    ADD_CLIENT: (state, data) => {
        state.client = data;
    },
    REMOVE_CLIENT: (state) => {
        state.client = null;
    },
    CLEAR_QUERY: state => {
        state.query = {
            client_id: '',
            redirect_uri: '',
            queryScopes: '',
            scopes: {},
            secret_key: '',
            input_email: '',
            input_phone: '',
        }
    },
    CLEAR_CLIENT: state => {
        state.client= {
            application_name: '',
            application_photo: '',
            company_info: { name: '' },
            domain: '',
            id: '',
            client_id: '',
            name: ''
        }
    },
};

export const getters = {
    GET_QUERY: state => state.query,
    GET_IS_QUERY: state => {
        return state.query.client_id !== '' 
			&& state.query.redirect_uri !== '' 
			&& state.query.queryScopes !== ''
    },
    GET_CLIENT: state => state.client,
    GET_IS_CLIENT: state => state.client.id !== '',
    GET_IS_AUTHENTICATED: state => state.authentication.isAuthenticated,
    GET_OPEN_ID: state => state.authentication.openId,
    GET_ACCESS_TOKEN: state => state.authentication.accessToken,
    GET_REFRESH_TOKEN: state => state.authentication.refreshToken,
    GET_SECRET_KEY: state => state.authentication.secretKey,
};

export const actions = {
    ADD_QUERY: ({ commit }, data) => {
        commit('ADD_QUERY', data);
    },
    SET_QUERY_CLIENT_ID: ({ commit }, data) => {
        commit('SET_QUERY_CLIENT_ID', data);
    },
    SET_QUERY_REDIRECT_URI: ({ commit }, data) => {
        commit('SET_QUERY_REDIRECT_URI', data);
    },
    SET_QUERY_SCOPES: ({ commit }, data) => {
        commit('SET_QUERY_SCOPES', data);
    },
    SET_QUERY_OBJ_SCOPES: ({ commit }, data) => {
        commit('SET_QUERY_OBJ_SCOPES', data);
    },
    CLEAR_QUERY: ({ commit }) => {
        commit('CLEAR_QUERY');
    },
    ADD_CLIENT: ({ commit }, data) => {
        commit('ADD_CLIENT', data);
    },
    CLEAR_CLIENT: ({ commit }) => {
        commit('CLEAR_CLIENT');
    },
    REMOVE_CLIENT: ({ commit }) => {
        commit('REMOVE_CLIENT');
    },
    REMOVE_EXPIRE_TOKEN({ commit}) {
        return new Promise(resolve => {
            commit('REMOVE_EXPIRE_TOKEN')
            resolve()
        })
    },
    REMOVE_ALL_AUTHENTICATED ({ commit }) {
        return new Promise(resolve => {
            commit('SET_REMOVE_ALL')
            resolve()
          })
    },
    SET_IS_AUTHENTICATED ({ commit }, isAuthenticated) {
        return new Promise(resolve => {
            commit('SET_IS_AUTHENTICATED', isAuthenticated)
            resolve()
          })
    },
    SET_AUTHENTICATED_ALL ({ commit }, obj) {
        return new Promise(resolve => {
            console.log('SET_AUTHENTICATED_ALL', obj)
            commit('SET_AUTHENTICATED_ALL', obj)
            resolve()
          })
    },
    SET_ACCESS_TOKEN ({ commit }, accessToken) {
        return new Promise(resolve => {
            commit('SET_ACCESS_TOKEN', accessToken)
            resolve()
          })
    },
    SET_REFRESH_TOKEN ({ commit }, refreshToken) {
        return new Promise(resolve => {
            commit('SET_REFRESH_TOKEN', refreshToken)
            resolve()
          })
    },
    SET_SECRET_KEY ({ commit }, secretKey) {
        return new Promise(resolve => {
            commit('SET_SECRET_KEY', secretKey)
            resolve()
        })
    },
};
